export default __webpack_public_path__ + "static/media/external-link-yellow.446d8cc3.svg";